import { cn } from '@discover-lib/utils';

type EmailSummaryProps = {
  email?: string | null;
  label?: string;
  onChange: () => void;
  className?: string;
};

/**
 * Read-only stand-in for the email input once a signup flow moves past the email step.
 * Presentational only; callers own the "go back" behaviour and any tracking.
 */
const EmailSummary = ({
  email,
  label = 'Email address',
  onChange,
  className,
}: EmailSummaryProps) => (
  <div className={cn('flex items-center justify-between', className)} data-email-summary>
    <div className="min-w-0">
      <p className="text-[13px] leading-5">{label}</p>
      <p className="truncate text-sm leading-5">{email}</p>
    </div>
    <button
      type="button"
      className="ml-4 !h-auto !w-auto shrink-0 !p-0 text-[13px] !font-normal leading-5 text-ds-brand-700 hover:underline"
      onClick={onChange}>
      Change
    </button>
  </div>
);

export default EmailSummary;
